/** xoshiro128** seeded pseudo-random generator. Deterministic across runs and engines. */
export class Rng {
  private s: Uint32Array = new Uint32Array(4);

  constructor(seed: number) {
    // splitmix32 to expand the seed into four non-zero words
    let x = seed >>> 0;
    for (let i = 0; i < 4; i++) {
      x = (x + 0x9e3779b9) >>> 0;
      let z = x;
      z = Math.imul(z ^ (z >>> 16), 0x85ebca6b) >>> 0;
      z = Math.imul(z ^ (z >>> 13), 0xc2b2ae35) >>> 0;
      this.s[i] = (z ^ (z >>> 16)) >>> 0;
    }
    if ((this.s[0] | this.s[1] | this.s[2] | this.s[3]) === 0) this.s[0] = 1;
  }

  /** Next unsigned 32-bit integer. */
  next(): number {
    const s = this.s;
    const result = Math.imul(rotl(Math.imul(s[1], 5) >>> 0, 7), 9) >>> 0;
    const t = (s[1] << 9) >>> 0;
    s[2] ^= s[0]; s[3] ^= s[1]; s[1] ^= s[2]; s[0] ^= s[3];
    s[2] ^= t;
    s[3] = rotl(s[3], 11);
    return result;
  }

  /** Float in [0, 1). */
  float(): number { return this.next() / 4294967296; }
  /** Integer in [0, maxExcl). */
  int(maxExcl: number): number { return Math.floor(this.float() * maxExcl); }
  /** Float in [a, b). */
  range(a: number, b: number): number { return a + this.float() * (b - a); }
  /** Serializable state for snapshots. */
  state(): number[] { return Array.from(this.s); }
}

function rotl(x: number, k: number): number { return ((x << k) | (x >>> (32 - k))) >>> 0; }
